export default {
	tenantId: "avivaAsia_demo",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "avivaasia--demo"
	}
}
